import { useQuery } from '@tanstack/react-query';

import { useDashboardConfig } from '@/hooks/useDashboardConfig';
import { createHttpHeader } from '@/utils/network/createHTTPHeaders';
import { decryptTreezorResponse } from '@/services/encryption/decryptTreezorResponse';
import { IUser } from '@/features/user/store/user.model';

type TUserInfoProps = {
  userId?: number;
};

export function useCardUserInfo({ userId }: TUserInfoProps) {
  const headers = createHttpHeader();
  const config = useDashboardConfig();

  const {
    data: userData,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['getUserInfo', userId],
    queryFn: async () => {
      const response = await fetch(`${config.api.baseUrl}/v1/users/${userId}`, {
        headers,
      });
      return (await decryptTreezorResponse<IUser>(response, { isSequential: true }))?.[0];
    },
    enabled: !!userId,
    staleTime: 120000,
  });

  return { isLoading, userData, isError };
}
